// 英文译文 · 销售订单 / 采购订单 / 出货单 / 装箱单 · key = 代码里的中文原文,一字不差
export default {
  // ── 销售订单 · 渠道 / 状态 ──
  "独立站": "Independent Site",
  "待确认": "Pending Confirmation",
  "已确认": "Confirmed",
  "等上游": "Awaiting Upstream",
  "待发货": "Awaiting Shipment",
  "已发货": "Shipped",
  "已签收": "Delivered",
  // ── 通用提示 ──
  "加载失败: {msg}": "Failed to load: {msg}",
  "删除失败: {msg}": "Delete failed: {msg}",
  "加载供应商失败: {msg}": "Failed to load suppliers: {msg}",
  "加载货代失败: {msg}": "Failed to load forwarders: {msg}",
  "已建 {no}": "Created {no}",
  "确认将 {no} 转到 {status}?": "Move {no} to \"{status}\"?",
  "已转移 · 库存已过账 {n} 行": "Status updated · Inventory posted for {n} lines",
  "请注意": "Please note",
  "合计": "Total",
  "状态历史": "Status History",
  "(初)": "(initial)",
  "误点取消?恢复回待确认": "Cancelled by mistake? Restore to Pending Confirmation",
  "误点取消?恢复回待提交": "Cancelled by mistake? Restore to Pending Submission",
  "误点取消?恢复回待发货代": "Cancelled by mistake? Restore to Pending Forwarder",
  // ── 销售订单 · 列表 ──
  "搜订单号/平台单号/买家/上游号/运单/产品编号": "Search order no. / platform no. / buyer / upstream no. / waybill no. / product code",
  "+ 新建销售单": "+ New Sales Order",
  "该店铺由外部系统(中间件)发货 · ERP 只记账": "This store is fulfilled by an external system (middleware) · The ERP only keeps the books",
  "外部发货": "Fulfilled Externally",
  "客户 / 买家": "Customer / Buyer",
  "平台单号": "Platform Order No.",
  "收货国": "Ship-to Country",
  "下单时间": "Order Date",
  "上游单号": "Upstream Order No.",
  "末端运单号": "Final Waybill No.",
  "平台已取消,但 ERP 已有下游单据,需人工处理": "Cancelled on the platform, but the ERP already has downstream documents · Needs manual handling",
  "平台已取消": "Cancelled on platform",
  "平台已发货 {date}": "Shipped on platform {date}",
  "{n} 行未匹配产品主表": "{n} lines not matched to the Product Master",
  "🔄 匹配SKU({n})": "🔄 Match SKU ({n})",
  "🔄 重新匹配SKU": "🔄 Re-match SKUs",
  "已自动判断:{reason}": "Auto-detected: {reason}",
  "照抄自": "Copied from",
  "随下游同步": "Synced from downstream",
  "跨公司直发时,下游公司确认发货后,链路上各家会自动照抄一张(来源「随下游同步」)。": "For intercompany drop-shipping, once the downstream company confirms shipment, each company up the chain automatically gets a copy (source: \"Synced from downstream\").",
  "中间件里没有这张单的订单 ID 记录,按平台单号找到的 —— 可能是别的店同号的单,核对后再手动填": "Not found under this order's ID in the middleware; matched by platform order number — may be another store's order with the same number, check before filling in manually",
  "中间件?按单号": "Middleware? (by number)",
  "运单不一致": "Waybill mismatch",
  "中间件已出面单 · 生成发货单时会自动填上": "The middleware has created the label · it will be filled in automatically when the shipment is created",
  "中间件": "Middleware",
  "从任一编号反查全链 · 平台订单 / 客户 → 销售订单 → 下游公司 → 出货 → 收款 / 平台结算 / 退款": "Trace the full chain from any number · platform order / customer → sales order → downstream companies → shipment → receipts / platform payouts / refunds",
  "输入订单号 / 平台单号(#1309)/ 运单号 / 客户名 / 出货单号 / 收款号 / 退款号": "Order no. / platform order (#1309) / waybill / customer / shipment no. / receipt no. / refund no.",
  "目前进度": "Current stage",
  "状态记录": "Status history",
  "按销售单的平台单号去一件代发中间件取运单号": "Fetch the waybill from the dropship middleware by the sales order's platform order number",
  "查运单号": "Find waybill",
  "拉单时产品库里还没有的编码,导入产品后点这里一次补上所有订单": "SKUs that were not in the product library when orders were pulled — click after importing products to match all orders at once",
  "按本单明细向上游下采购单": "Place a purchase order upstream from this order's lines",
  "📥 派采购": "📥 Create PO",
  "按本单明细建出货单": "Create a shipment from this order's lines",
  "🚚 建发货": "🚚 Create Shipment",
  "给买家开销售发票": "Issue a sales invoice to the buyer",
  "🧾 开发票": "🧾 Issue Invoice",
  // ── 销售订单 · 删除 / 匹配 / 保存 ──
  "确认删除 {no}?": "Delete {no}?",
  "这是平台拉单 · 删除后下次拉单会重新拉进来。": "This order came from a platform order sync · It will be pulled in again on the next sync.",
  "删除销售单": "Delete Sales Order",
  "{msg} · 请先在【产品库 → 编号主表】导入对应编号": "{msg} · Import the matching codes in [Products → Product Master] first",
  "匹配失败: {msg}": "Matching failed: {msg}",
  "客户 / 平台原始订单号 必填": "Customer and platform original order no. are required",
  "客户必填": "Customer is required",
  // ── 销售订单 · 派生(派采购单 / 建发货单 / 开发票)──
  "📥 派采购单": "📥 Create Purchase Order",
  "🚚 建发货单": "🚚 Create Shipment",
  "请选供应商": "Please select a supplier",
  "请选货代": "Please select a forwarder",
  "重量必填": "Weight is required",
  "本单已派生": "Already created from this order",
  "发货单": "Shipment",
  "运单": "Waybill No.",
  "发票": "Invoice",
  "选上游供应商": "Select upstream supplier",
  "入库运费": "Inbound Freight",
  "自动带来货价": "Auto-fill Supplier Price",
  "取该供应商生效中的来货价 · 取不到的行单价留 0 待补": "Uses this supplier's current supplier price · Lines without one get unit price 0, to fill in later",
  "选货代渠道": "Select forwarder channel",
  "产品线代码": "Product Line Code",
  "如 THPHR · 留空用 DEFAULT": "e.g. THPHR · Leave blank for DEFAULT",
  "包裹重量(g)": "Parcel Weight (g)",
  "运费成本": "Freight Cost",
  "填了成本但不填收客户价 · 自动按货代默认加收比例算": "If you enter the cost but not the customer price · It is calculated with the forwarder's default markup",
  "运费(收客户)": "Freight (Charged to Customer)",
  "触发链路完成": "Complete Order Chain",
  "本司是链路末端(直接对终端消费者发货)时打开": "Turn on when this company is the end of the chain (ships directly to the end consumer)",
  "发票类型": "Invoice Type",
  "商业发票 commercial": "Commercial Invoice",
  "形式发票 proforma": "Proforma Invoice",
  "出口发票 export": "Export Invoice",
  "增值税发票 vat": "VAT Invoice",
  "普通发票 general": "General Invoice",
  "小数 · 如 0.13 = 13% · 留空表示不计税": "Decimal · e.g. 0.13 = 13% · Leave blank for no tax",
  "账期(天)": "Payment Term (days)",
  "0 = 不设到期日": "0 = no due date",
  "留空自动写「由销售单 XXX 派生」": "Leave blank to auto-fill \"Created from sales order XXX\"",
  // ── 销售订单 · 新建 / 编辑 / 详情 ──
  "编辑销售单": "Edit Sales Order",
  "平台拉单": "Platform Order",
  "新建销售订单": "New Sales Order",
  "平台原始订单号": "Platform Original Order No.",
  "上游自有单号": "Upstream's Own Order No.",
  "按渠道规则自动选(系统设置 → 跨公司推单)": "Auto by channel rule (Settings → Inter-company Push)",
  "来源渠道": "Source channel",
  "推给下游时按来源渠道选下家(系统设置 → 跨公司推单);选「其他」的要手工选推给谁。": "When pushing downstream, the target company follows the source channel (Settings → Inter-company Push); for \"Other\" choose the target by hand.",
  "订单折扣": "Order Discount",
  "搜索编号/名称": "Search code / name",
  "折扣": "Discount",
  "保存(草稿)": "Save (draft)",
  "销售单 {no}": "Sales Order {no}",
  "销售单详情": "Sales Order Details",
  "收货": "Ship To",
  // ── 采购订单 · 入库运费分摊 ──
  "跟公司默认": "Company default",
  "按重量": "By weight",
  "按金额": "By amount",
  "按数量": "By quantity",
  "手工指定": "Set manually",
  "按金额(缺重量退回)": "By amount (fallback: weight missing)",
  "按数量(金额为0退回)": "By quantity (fallback: amount is 0)",
  // ── 采购订单 · 状态 ──
  "待提交": "Pending Submission",
  "部分到货": "Partially Received",
  "全部到货": "Fully Received",
  "已闭合": "Closed",
  // ── 采购订单 · 列表 / 表单 / 详情 ──
  "供应商必填": "Supplier is required",
  "确认删除采购单 {no}?": "Delete purchase order {no}?",
  "运费已更新 · 已追加成本调整流水 {n} 条": "Freight updated · {n} cost adjustment transactions added",
  "运费已更新": "Freight updated",
  "搜订单号/SO号/平台号": "Search order no. / SO no. / platform no.",
  "+ 新建采购单": "+ New Purchase Order",
  "触发 SO": "Triggering SO",
  "编辑采购单": "Edit Purchase Order",
  "新建采购订单": "New Purchase Order",
  "整单运费录一次 · 保存后按此分到每行 · 某行要指定就填右侧「指定运费」": "Enter the order's total freight once · On save it is allocated to each line by this method · To fix a line's amount, fill in \"Manual Freight\" on the right",
  "触发 SO 号": "Triggering SO No.",
  "来自哪张销售单(冗余记录)": "Which sales order it came from (for reference)",
  "指定运费": "Manual Freight",
  "自动分摊": "Auto-allocate",
  "采购单 {no}": "Purchase Order {no}",
  "上游确认单号": "Upstream Confirmation No.",
  "收货地": "Receiving Address",
  "分摊方式": "Allocation Method",
  "(公司默认)": "(company default)",
  "分摊运费": "Allocated Freight",
  "落地单价": "Landed Unit Cost",
  "分摊依据": "Allocation Basis",
  "调整运费": "Adjust Freight",
  "调整入库运费 · {no}": "Adjust Inbound Freight · {no}",
  "这张单已经入库 · 保存后不改原入库流水,会追加「成本调整」流水记录新旧成本": "This order has already been received into stock · Saving won't change the original inbound transactions; a \"Cost Adjustment\" transaction recording the old and new cost will be added",
  "整单运费": "Total Freight",
  "当前分摊": "Current Allocation",
  "调整原因": "Reason",
  "如:货代 9 月账单到了 / 分摊方式改按数量": "e.g. Forwarder's September bill arrived / switched allocation to by quantity",
  "保存并重算": "Save & Recalculate",
  // ── 出货单 · 状态 ──
  "待发货代": "Pending Forwarder",
  "已给货代": "Sent to Forwarder",
  "已出运单": "Waybill No. Assigned",
  "在途": "In Transit",
  // ── 出货单 · 列表 / 填运单号 ──
  "运单号必填": "Waybill No. is required",
  "确认删除出货单 {no}?": "Delete shipment {no}?",
  "先选销售单": "Select a sales order first",
  "选货代": "Select a forwarder",
  "确认 {no} → {status}?": "Confirm {no} → \"{status}\"?",
  "🚚 出货单": "🚚 Shipments",
  "搜出货单号/SO号/运单号/tracking": "Search shipment no. / SO no. / waybill no.",
  "+ 新建出货单": "+ New Shipment",
  "出货单号": "Shipment No.",
  "国": "Country",
  "运单号": "Waybill No.",
  "费用@@运费": "Freight",
  "收@@运费": "Charged",
  "改运单号": "Edit Waybill No.",
  "显示已取消的": "Show cancelled",
  "销售单号": "Sales order",
  "箱数 / 重量": "Cartons / weight",
  "{n} 箱": "{n} cartons",
  "货代 / 渠道": "Forwarder / service",
  "运单号 / Tracking": "Waybill / tracking",
  "发货 / 签收": "Shipped / delivered",
  "📮 填运单号": "📮 Enter Waybill No.",
  "货代给的运单号": "Waybill No. from the forwarder",
  "留空则同运单号": "Leave blank to use the Waybill No.",
  "自动推进状态": "Auto-advance Status",
  "打开 = 填完自动转「已出运单」· 本司是链路末端时还会回填销售单的末端运单号": "On = automatically moves to \"Waybill No. Assigned\" when saved · If this company is the end of the chain, also fills in the sales order's final waybill no.",
  // ── 出货单 · 新建 / 详情 ──
  "新建出货单": "New Shipment",
  "选销售单": "Select Sales Order",
  "输入订单号搜": "Type an order no. to search",
  "地址": "Address",
  "渠道产品线": "Channel Product Line",
  "重量(克)": "Weight (g)",
  "收客户运费": "Freight Charged to Customer",
  "运费币": "Freight Currency",
  "回填五号绑定": "Backfill Order Chain",
  "是(末端出货)": "Yes (final-leg shipment)",
  "否": "No",
  "出货明细": "Shipment Lines",
  "发货数量": "Ship Qty",
  "单件重量(g)": "Unit Weight (g)",
  "先选销售单 · 明细自动带出": "Select a sales order first · Lines are filled in automatically",
  "出货单 {no}": "Shipment {no}",
  "出货单": "Shipment",
  "所属 SO": "Sales Order",
  "重量": "Weight",
  "收客户": "Charged to Customer",
  "回填链": "Chain Backfill",
  "发货日期": "Ship Date",
  "签收": "Delivered At",
  "分配运单号(转 waybill_assigned 时提交)": "Assign Waybill No. (submitted when moving to waybill_assigned)",
  "运单号(货代给的)": "Waybill No. (from the forwarder)",
  "Tracking(常等于运单号)": "Tracking (usually the same as the Waybill No.)",
  // ── 装箱单 ──
  "作废 {no} 后,该发货单可以重新开一张装箱单。请填写作废原因:": "After voiding {no}, a new packing list can be issued for this shipment. Please enter the reason for voiding:",
  "作废装箱单": "Void Packing List",
  "如:箱数填错 / 重新分箱": "e.g. wrong carton count / re-packed",
  "必须填原因": "A reason is required",
  "📦 装箱单 Packing List": "📦 Packing Lists",
  "搜单号/运单号/买家/集装箱号": "Search no. / waybill no. / buyer / container no.",
  "有效": "Valid",
  "出货填运单号时自动生成 · 无需手工建": "Generated automatically when a shipment gets its waybill no. · No need to create manually",
  "三单据的第三张": "The third of the three trade documents",
  "(买家→卖家)·": " (buyer → seller) · ",
  "(卖家→买家)·": " (seller → buyer) · ",
  "(卖家→买家,随货)。": " (seller → buyer, travels with the goods).",
  "装箱单在": "Packing lists are ",
  "出货拿到运单号那一刻自动开出": "issued automatically the moment a shipment gets its waybill no.",
  " · 一个发货单一张 · 箱数/毛净重/唛头这些仓库现场信息可以补填。": " · One per shipment · On-site warehouse details (cartons, gross/net weight, shipping marks) can be filled in later.",
  "装箱单号": "PL No.",
  "买家": "Buyer",
  "出货日": "Ship Date",
  "箱数": "Cartons",
  "毛重 / 净重": "Gross / Net Weight",
  "净": "Net",
  "自动": "Auto",
  "手工": "Manual",
  "补填": "Fill In",
  "还没有装箱单 —— 去【收发货管理】给发货单填运单号,会自动开出": "No packing lists yet — go to [Shipments] and enter a waybill no. on a shipment; one will be issued automatically",
  "装箱单 {no}": "Packing List {no}",
  "体积": "Volume",
  "尺寸": "Dimensions",
  "集装箱 / 封条": "Container / Seal",
  "唛头": "Shipping Marks",
  "作废原因": "Void Reason",
  "箱号": "Carton No.",
  "品名": "Description",
  "毛重(kg)": "Gross Weight (kg)",
  "补填装箱信息": "Fill In Packing Details",
  "SKU/数量来自上游发货单,不在这里改。这里填的是": "SKU / Qty come from the shipment and are not edited here. Here you enter details ",
  "仓库现场才知道": "only known on-site at the warehouse",
  "的信息。": ".",
  "毛重 (kg)": "Gross Weight (kg)",
  "净重 (kg)": "Net Weight (kg)",
  "体积 (m³)": "Volume (m³)",
  "L×W×H cm · 如 40×30×25": "L×W×H cm · e.g. 40×30×25",
  "海运专用(可空)": "Ocean Freight Only (optional)",
  "集装箱号": "Container No.",
  "封条号": "Seal No.",
  "报关": "Customs",
  "Marks & Nos · 境外报关用": "Marks & Nos · For overseas customs",
  // 2026-09-27 跨公司推单
  "勾选的单都已经推过或已取消": "The selected orders have all been pushed or cancelled",
  "请选推给哪家": "Please choose which company to push to",
  "已推 {n} 张": "Pushed {n}",
  "撤回推给{company}的单?对方还没确认才能撤,撤回后采购单作废。": "Revoke the push to {company}? Only possible before they confirm; the purchase order will be voided.",
  "撤回推送": "Revoke Push",
  "📨 推给下游({n})": "📨 Push downstream ({n})",
  "来自 {company}": "From {company}",
  "采购单 {po} → 对方销售单 {so}": "PO {po} → their SO {so}",
  "按来货价生成采购单,对方公司自动建销售单": "Creates a PO at the supply price; the other company gets a sales order automatically",
  "📨 推给下游": "📨 Push downstream",
  "推给下游公司 · {n} 张": "Push to downstream company · {n}",
  "推给": "Push to",
  "选内部供应商": "Choose an internal supplier",
  "按本公司对它的来货价生成采购单(直发客户,不入库),对方公司自动建一张草稿销售单,带终端收货地址。对方发货后,运单号会自动回传到这张单。": "Creates a PO at our supply price for them (drop-ship, no stock-in); they get a draft sales order with the end customer's address. Once they ship, the tracking number flows back to this order.",
  "推送": "Push",
  "跨公司链路": "Inter-company Chain",
  "上游(谁推来的)": "Upstream (pushed from)",
  "本公司采购单": "Our PO",
  "对方销售单": "Their SO",
  "已回传给上游:{list}": "Sent back upstream: {list}",
  "确认发货": "Confirm Shipped",
  "请选择产品": "Please select a product",
  "平台仓发货(亚马逊 FBA)· ERP 只记账,不推下游": "Fulfilled by the platform warehouse (Amazon FBA) · ERP records only, not pushed downstream",
  "拉进来时平台上已经发货了(不是 ERP 发的)· 只记账": "Already shipped on the platform when pulled in (not by ERP) · records only",
  "拉入时已发": "Shipped before pull",
  "最晚发货 {date}": "Ship by {date}",
  "已回传平台": "Sent to platform",
  "回传平台失败": "Send to platform failed",
  "平台上的 SKU 和产品库编号对不上时,对照一次,以后拉单自动匹配": "When the platform SKU differs from the product code, map it once and future orders match automatically",
  "对照到产品": "Map to product",
  "平台 SKU": "Platform SKU",
  "对照后:以后拉进来的单自动匹配到这个产品;已有订单里这个 SKU 的行也马上补上。推给下游时按产品库编号推。": "After mapping: future orders match this product automatically, and existing order lines with this SKU are matched right away. Pushes downstream use the product code.",
  "对照表在【产品库】的「平台 SKU 对照」里,可以删。": "Mappings are listed under Product Library → Platform SKU mapping, where they can be deleted.",
  "运单号回传平台 {n} 张": "Tracking sent to platform for {n} orders",
  // 2026-10-12 散单
  "散单": "Retail orders",
  "代销商": "Dealer",
  "只有「散单」页 · 只看自己的单": "Retail orders page only · sees own orders only",
  "代销商账号要选绑定的代销商": "A dealer account must be linked to a dealer",
  "选绑定的代销商": "Select the linked dealer",
  "代销商登录后只看得到「散单」页,只能看、改、下自己的单。代销商在【散单 → 代销商配置】里新增。": "After login a dealer only sees the Retail orders page and can only view, edit and place their own orders. Add dealers under Retail orders → Dealers.",
  "到散单页处理 →": "Handle on Retail orders page →",
  "代销商名称必填": "Dealer name is required",
  "已新增代销商 {name}": "Dealer {name} added",
  "先填零售价和折扣(比如 0.85)": "Fill in the retail price and the rate first (e.g. 0.85)",
  "请选产品": "Please select a product",
  "结算价要大于 0": "Settlement price must be greater than 0",
  "删掉 {code} 的价格?已经下过的单不受影响。": "Delete the price of {code}? Orders already placed are not affected.",
  "删除价格": "Delete price",
  "改价": "Edit price",
  "结算价 {v}": "Settlement price {v}",
  "删除前结算价 {v}": "Settlement price before deletion {v}",
  "零售价": "Retail price",
  "折扣价": "Discount price",
  "结算价": "Settlement price",
  "+ 新增代销商": "+ New dealer",
  "还没有代销商 · 点右上角新增,或在客户库里把客户类型改成「代销商」": "No dealers yet · add one at the top right, or set a customer's type to \"Dealer\" in Customers",
  "可下单产品 {p} · 散单 {o}": "Orderable products {p} · retail orders {o}",
  "还没开登录账号": "No login account yet",
  "登录账号在用户管理里开:角色选「代销商」并绑定代销商": "Create the login in Users: choose role \"Dealer\" and link the dealer",
  "去用户管理 →": "Go to Users →",
  "{name} 的价格表": "Price list of {name}",
  "价格表": "Price list",
  "搜编号 / 名称": "Search code / name",
  "改价记录": "Price history",
  "+ 加产品": "+ Add product",
  "代销商只能下这里配了价格、并且启用的产品。结算价 = 代销商付给公司的价,就是销售单上的单价;零售价、折扣价只做参考。": "Dealers can only order products that have an active price here. Settlement price = what the dealer pays the company, used as the sales order unit price; retail and discount prices are for reference only.",
  "新增代销商": "New dealer",
  "比如 FIELD EARTH刘佳零售及线下门店": "e.g. FIELD EARTH Liu Jia retail & store",
  "会在客户库里建一个类型「代销商」的客户,结算币种人民币。": "Creates a customer of type \"Dealer\" in Customers, settled in CNY.",
  "加产品": "Add product",
  "输入编号或名称搜索": "Type a code or name to search",
  "按折扣算": "Apply rate",
  "→ 折扣价": "→ Discount price",
  "→ 结算价": "→ Settlement price",
  "必填 · 代销商付给公司的价": "Required · what the dealer pays the company",
  "改价记录 · {name}": "Price history · {name}",
  "动作": "Action",
  "改动": "Change",
  "{name} · 下单、传付款截图、看审批和发货进度": "{name} · place orders, upload payment proof, track approval and shipping",
  "代销商下的零售单 · 付款截图审批 · 审批通过生成收款单": "Retail orders from dealers · payment-proof approval · a receipt is created on approval",
  "代销商配置": "Dealers",
  "已提交审批": "Submitted for approval",
  "撤回后回到草稿,可以修改后再提交。": "Withdrawing returns it to draft; you can edit and submit again.",
  "撤回 {no}?": "Withdraw {no}?",
  "已撤回": "Withdrawn",
  "核对付款截图和结算金额无误后通过 · 通过后自动生成一张待核对的收款单": "Approve after checking the payment proof and settlement amount · a receipt pending reconciliation is created",
  "审批通过 {no}": "Approve {no}",
  "备注(选填)": "Note (optional)",
  "已通过 · 收款单 {no}": "Approved · receipt {no}",
  "写清楚原因,代销商改完可以重新提交": "Give a clear reason; the dealer can fix it and resubmit",
  "驳回 {no}": "Reject {no}",
  "驳回原因(必填)": "Reason (required)",
  "驳回必须写原因": "A reason is required to reject",
  "已审批的单取消后,自动生成的收款单一起作废(还没核对到账才行)": "Cancelling an approved order also voids its auto-created receipt (only if not yet reconciled)",
  "取消后不能恢复": "This cannot be undone",
  "取消 {no}?": "Cancel {no}?",
  "原因(选填)": "Reason (optional)",
  "确认取消": "Confirm cancel",
  "剪贴板里没有图片 · 先在微信里复制付款截图": "No image on the clipboard · copy the payment screenshot in WeChat first",
  "请选代销商": "Please select a dealer",
  "每一行都要选产品": "Every line needs a product",
  "提交审批前要先传付款截图": "Upload the payment proof before submitting",
  "单据已保存,但这些截图没传上去:{list}": "Order saved, but these screenshots failed to upload: {list}",
  "已保存并提交审批": "Saved and submitted for approval",
  "全部代销商": "All dealers",
  "搜单号 / 收货人 / 电话 / 产品编号 / 付款单号": "Search order no. / recipient / phone / product code / payment ref",
  "审批人:{name}": "Approver: {name}",
  "审批:任一管理员(未指定审批人)": "Approval: any admin (no approver set)",
  "+ 新增散单": "+ New retail order",
  "共 {n} 件": "{n} pcs",
  "收货人": "Recipient",
  "结算金额": "Settlement amount",
  "零售 {v}": "Retail {v}",
  "付款截图": "Payment proof",
  "没传": "Missing",
  "老系统": "Legacy",
  "建单 {by} · {at}": "Created {by} · {at}",
  "提交 {by} · {at}": "Submitted {by} · {at}",
  "审批 {by} · {at}": "Reviewed {by} · {at}",
  "已驳回:{c}": "Rejected: {c}",
  "改完重新提交即可": "Fix it and submit again",
  "价格表 {v}": "Price list {v}",
  "结算小计": "Settlement subtotal",
  "结算合计": "Settlement total",
  "零售合计 {v}": "Retail total {v}",
  "待核对到账": "Pending reconciliation",
  "已核对": "Reconciled",
  "去收付款管理 →": "Go to Cash →",
  "还没传付款截图": "No payment proof uploaded yet",
  "记录": "History",
  "取消散单": "Cancel order",
  "撤回": "Withdraw",
  "修改散单": "Edit retail order",
  "新增散单": "New retail order",
  "收货人姓名": "Recipient name",
  "手机或固话": "Mobile or landline",
  "请填收货人姓名": "Enter the recipient name",
  "请填收货电话": "Enter the recipient phone",
  "收货电话只能填数字(可带 + - 括号)": "Recipient phone may only contain digits (+ - and brackets allowed)",
  "选代销商": "Select dealer",
  "公司还没给你配可下单的产品价格 · 请联系公司": "No product prices have been set up for you yet · please contact the company",
  "这个代销商还没配价格 · 先到「代销商配置」里加产品": "This dealer has no prices yet · add products under Dealers first",
  "留空 = 按价格表 · 填了会留痕": "Blank = price list · an override is logged",
  "区县 + 详细地址": "District + street address",
  "邮编(选填)": "Postcode (optional)",
  "转账流水号 / 微信支付单号(选填)": "Transfer ref / WeChat Pay no. (optional)",
  "付款说明(选填)": "Payment note (optional)",
  "或点这里后按 Ctrl+V 粘贴微信里复制的付款截图": "or click here and press Ctrl+V to paste a payment screenshot copied from WeChat",
  "提交审批前必须有": "required before submitting",
  "保存并提交审批": "Save and submit",
  // 2026-10-12 散单第二期 · 发货
  "请选发货账号": "Please select the fulfilment account",
  "选了外部发货方之后,散单审批通过就会自动推过去,在智邦建出库单(扣库存)。确定?": "Once an external fulfiller is set, approved retail orders are pushed to it automatically and a Zhibang outbound order is created (stock is deducted). Continue?",
  "散单发货方": "Retail order fulfiller",
  "选了之后,散单审批通过就会自动推过去,由一件代发中间件在司南聚水潭下订单(扣聚水潭库存,司南仓库照常发货)。确定?": "Once set, approved retail orders are pushed automatically and the dropship middleware places an order in Sinan JST (JST stock is deducted; the Sinan warehouse ships as usual). Continue?",
  "审批通过后自动推给它:一件代发中间件在司南聚水潭下一张手工订单(店铺「线下」· 线上单号 = 散单号 · 已付款),司南仓库在聚水潭里照常审核发货,中间件按单号查回物流,ERP 每 5 分钟同步回来。": "After approval it is pushed automatically: the dropship middleware places a manual order in Sinan JST (shop \"Offline\" · online order no. = retail order no. · paid). The Sinan warehouse reviews and ships it in JST as usual; the middleware reads the tracking back by order no., and the ERP syncs every 5 minutes.",
  "发货仓": "Ship from",
  "智邦直接出库(添来仓)": "Zhibang direct outbound (Tianlai warehouse)",
  "司南聚水潭下单": "Order in Sinan JST",
  "货在哪边就选哪边 · 可售库存也按这里算(司南聚水潭只算聚水潭的可用数)": "Pick where the stock is · available stock follows this too (Sinan JST counts only JST available quantity)",
  "代销商零售单审批通过后,交给谁发货、要不要走链路记账": "Who ships approved dealer retail orders, and whether to book them through the intercompany chain",
  "不设": "Not set",
  "外部平台账号": "External platform account",
  "本公司自己发货": "Ship ourselves",
  "选发货账号": "Select fulfilment account",
  "审批通过后自动推给它:一件代发中间件会在智邦建直接出库单(扣库存),仓库在中间件「代发订单系统 → 发货回填」填物流,ERP 每 5 分钟同步回来。": "Approved orders are pushed automatically: the dropship middleware creates a direct Zhibang outbound order (stock is deducted), the warehouse enters tracking under Dropship orders → Shipping in the middleware, and the ERP syncs it back every 5 minutes.",
  "审批通过后在散单页点「回填物流」记已发货。": "After approval, click \"Enter tracking\" on the Retail orders page to mark it shipped.",
  "不设:审批通过后停在「待发货」,可以手动回填物流。": "Not set: approved orders wait in \"To ship\"; tracking can be entered manually.",
  "要选外部账号,先在【外部平台】加一个「一件代发中间件」。": "To use an external account, first add a \"Dropship middleware\" under External platforms.",
  "记账走链路": "Book via chain",
  "不走链路": "No chain",
  "选了的话,审批通过时按来货价给这家内部供应商推一张直发采购单(对方建销售单),发货后整条链补成已发货并开票 · 只记账,不影响发货。产品或来货价没配齐的单不推,会在单上写原因。": "If set, approval pushes a drop-ship purchase order to this internal supplier at the cost price (they get a sales order); after shipping the whole chain is marked shipped and invoiced · bookkeeping only, shipping is unaffected. Orders with missing products or cost prices are not pushed and the reason is noted on the order.",
  "可售库存": "Available stock",
  "推给发货方后,会在智邦建出库单(扣库存),仓库照单发货。": "Pushing creates a Zhibang outbound order (stock is deducted) and the warehouse ships it.",
  "推送 {no}?": "Push {no}?",
  "正在推给发货方(智邦出库可能要几十秒)…": "Pushing to the fulfiller (the Zhibang outbound may take tens of seconds)…",
  "已推给发货方 · 智邦出库 {ck}": "Pushed to the fulfiller · Zhibang outbound {ck}",
  "推给发货方后,会在司南聚水潭下一张已付款的单({线下}店铺),司南照单发货。": "After pushing, a paid order (store {线下}) is created in Sinan Jushuitan and Sinan ships it.",
  "正在推给发货方(司南聚水潭下单可能要几十秒)…": "Pushing to the fulfiller (creating the Sinan Jushuitan order may take tens of seconds)…",
  "已推给发货方 · 司南聚水潭订单 {ref}": "Pushed to the fulfiller · Sinan Jushuitan order {ref}",
  "推送失败:{err} · 系统会自动重试(间隔越来越长,最长 6 小时),处理好也可以再点「推给发货方」": "Push failed: {err} · retried automatically (backing off up to 6 hours); after fixing it you can also click Push again",
  "推送失败:{err} · 系统每 5 分钟会自动重试": "Push failed: {err} · the system retries every 5 minutes",
  "已同步 · {st}": "Synced · {st}",
  "物流单号必填": "Tracking number is required",
  "已回填物流 · 已发货": "Tracking entered · shipped",
  "发货": "Shipping",
  "已试 {n} 次": "{n} attempts",
  "智邦出库单": "Zhibang outbound",
  "发货时间": "Shipped at",
  "推送问题": "Push issue",
  "记账链路": "Chain bookkeeping",
  "还没设发货方 · 管理员到【系统设置 → 散单】选,或者直接点「回填物流」": "No fulfiller set · an admin can choose one under Settings → Retail orders, or click \"Enter tracking\"",
  "同步发货状态": "Sync shipping status",
  "回填物流": "Enter tracking",
  "推给发货方": "Push to fulfiller",
  "回填物流 · {no}": "Enter tracking · {no}",
  "物流公司": "Carrier",
  "比如 顺丰 / 中通": "e.g. SF Express / ZTO",
  "北京时间 · 经营报表按它算收入月份": "Beijing time · the operating report books revenue in this month",
  "确认已发货": "Confirm shipped",
  "已开始重算库存 · 1~3 分钟后点「刷新」看新数": "Stock recalculation started · click Refresh in 1–3 minutes",
  "库存正在重算中 · 稍后点「刷新」": "Stock is being recalculated · click Refresh later",
  "全部代销商的产品": "Products of all dealers",
  "重算库存": "Recalculate stock",
  "库存截至 {at}(北京时间)": "Stock as of {at} (Beijing time)",
  "正在重算…": "Recalculating…",
  "库存还没算过 · 请联系公司": "Stock has not been calculated yet · please contact the company",
  "还没有库存数据 · 点「重算库存」": "No stock data yet · click \"Recalculate stock\"",
  "可售": "Available",
  "智邦添来仓": "Zhibang (Tianlai warehouse)",
  "司南聚水潭": "Sinan Jushuitan",
  "已审批待发": "Approved, not shipped",
  "ERP 待推": "ERP not pushed",
  "下单日期": "Order date",
  "选择日期": "Pick dates",
  "本月": "This month",
  "上月": "Last month",
  "{y} 年 {m} 月": "{y}-{m}",
  "再点结束日期 · 同一天再点一下 = 只看这天": "Now click the end date · click the same day again for just that day",
  "先点开始日期": "Click the start date",
  "日@@周": "Su",
  "一@@周": "Mo",
  "二@@周": "Tu",
  "三@@周": "We",
  "四@@周": "Th",
  "五@@周": "Fr",
  "六@@周": "Sa",
  "今天": "Today",
  "昨天": "Yesterday",
  "近 7 天": "Last 7 days",
  "近 30 天": "Last 30 days",
  "近 90 天": "Last 90 days",
  // 2026-10-15 销售订单列表:发货日期来源 + FBA
  "本单出货单 / 零售包裹的发货日": "Ship date of this order's shipment / retail parcel",
  "平台发货时间(链路顶上的平台单)": "Platform ship time (from the platform order at the top of the chain)",
  "订单转「已发货」的时间": "When the order was marked shipped",
  "FBA · 亚马逊仓发": "FBA · shipped by Amazon",
  "平台下单日期(链路顶上的平台单)": "Platform order date (from the platform order at the top of the chain)",
  "上游推到本公司的日期": "Date the upstream company pushed it to us",
  "推来 {d}": "pushed {d}",
  "亚马逊仓发(FBA):亚马逊仓库直接发货,没有我们这边的运单号 · 推到这里只为链路记账开票": "Fulfilled by Amazon (FBA): shipped directly from Amazon's warehouse, so there is no waybill on our side · pushed here only for chain accounting and invoicing",
  // 2026-10-19 散单 · 可售清单增删
  "已加 {n} 个 · {m} 个本来就在清单里": "Added {n} · {m} already on the list",
  "已加 {n} 个": "Added {n}",
  "有 {n} 个代销商配了「{code}」的价:移出后这里不再列出,代销商那边照样看得到、能下单。要停卖请到【代销商配置】停价。确定移出?": "{n} dealer(s) have a price for \"{code}\": after removal it is no longer listed here, but dealers can still see and order it. To stop selling it, disable the price under [Dealer settings]. Remove anyway?",
  "把「{code}」移出可售清单?": "Remove \"{code}\" from the available-stock list?",
  "移出可售清单": "Remove from available-stock list",
  "移出": "Remove",
  "已移出": "Removed",
  "本公司可售清单": "Our available-stock list",
  "新增产品": "Add products",
  "可售清单还是空的 · 点「新增产品」从本公司产品库里选": "The available-stock list is empty · click \"Add products\" to pick from our product library",
  "新增产品到可售清单": "Add products to the available-stock list",
  "只能选本公司产品库里的产品(归档的不列)· 可以一次选多个": "Only products in our product library can be picked (archived ones are hidden) · you can pick several at once",
  "(已在清单)": "(already listed)",
  "加进清单": "Add to list",
  // 2026-10-19 散单手机版
  "从相册选 / 拍照": "Pick from album / take photo",
  "搜单号 / 收货人 / 电话 / 产品": "Search order no. / recipient / phone / product",
  "筛选": "Filter",
  "+ 新增": "+ New",
  // 2026-10-20 散单:销售渠道 + 渠道默认折扣 + 代销商最低折扣 · 每行折扣可改
  "代销商下单时自己改的折扣不能低于这个数(0.4 = 4 折)· 公司配的渠道折扣、公司代录不受限 · 留空 = 不限": "When ordering, the dealer can't set a discount below this (0.4 = 40% of retail) · company channel discounts and orders entered by the company aren't limited · blank = no limit",
  "{name} 的最低折扣": "Minimum discount for {name}",
  "比如 0.4": "e.g. 0.4",
  "渠道名称必填": "Channel name is required",
  "删除渠道「{name}」?": "Delete channel “{name}”?",
  "按价格表": "Per price list",
  "{d} 折": "{d}/10 of retail",
  "最低折扣 {v}": "Min. discount {v}",
  "折扣不限": "No discount limit",
  "设最低折扣": "Set min. discount",
  "销售渠道": "Sales channel",
  "+ 新增渠道": "+ New channel",
  "下散单时选渠道:每行结算价默认按「零售价 × 渠道默认折扣」(行上还能再改,改了会标红给审批人看)· 没填默认折扣 = 按价格表。可以限定只给某个代销商用。": "Pick a channel when placing a dealer order: each line's settlement price defaults to “retail × channel default discount” (still editable per line; edits are flagged in red for the approver) · no default discount = per price list. A channel can be limited to one dealer.",
  "给谁用": "Available to",
  "所有代销商": "All dealers",
  "默认折扣": "Default discount",
  "修改渠道": "Edit channel",
  "新增渠道": "New channel",
  "比如 线下门店零售 / 活动 / 抖音": "e.g. In-store retail / Promotion / Douyin",
  "比如 0.55": "e.g. 0.55",
  "0.55 = 55 折,结算价 = 零售价 × 0.55 · 留空 = 按价格表": "0.55 = 55% of retail, settlement = retail × 0.55 · blank = per price list",
  "改价 · 价格表 {v}": "Price changed · price list {v}",
  "按渠道折扣": "Channel discount",
  "选渠道(选填)": "Pick a channel (optional)",
  "还没配渠道": "No channels set up",
  "默认 {d} 折": "default {d}/10",
  "选了渠道,每行默认按「零售价 × 渠道折扣」,行上还能再改": "With a channel picked, each line defaults to “retail × channel discount”; still editable per line",
  "0.55 = 55 折 · 留空 = 按渠道 / 价格表 · 改了会留痕": "0.55 = 55% of retail · blank = per channel / price list · changes are recorded",
  "留空 = 按折扣 / 渠道 / 价格表 · 填了会留痕": "Blank = per discount / channel / price list · filling it in is recorded",
  "你的最低折扣 {v}(低于它提交不了)": "Your minimum discount is {v} (orders below it can't be submitted)",
  "先选代销商": "Pick a dealer first",
  // 2026-10-20 代销商自己建渠道
  "下散单时选渠道:每行结算价默认按「零售价 × 渠道默认折扣」,行上还能再改。公司配的渠道只能选;你自己建的渠道只给你自己用,能改、能停用。": "Pick a channel when placing an order: each line's settlement price defaults to retail price × the channel's default discount, and can still be changed per line. Channels set up by the company can only be selected; channels you create are for your own use, and you can edit or disable them.",
  "默认折扣不能低于你的最低折扣 {v}。": "The default discount can't be below your minimum discount {v}.",
  "代销商也能在自己的「销售渠道」页签建只给自己用的渠道(标「代销商自建」,不能低于他的最低折扣)。": "Dealers can also create channels for their own use on their own \"Sales channels\" tab (marked \"Dealer-created\"; not below their minimum discount).",
  "谁建的": "Created by",
  "自己建的": "Mine",
  "公司配的": "Company",
  "代销商自建": "Dealer-created",
  "公司配的,只能选": "Set by company · select only",
  "代销商自己建的渠道只给他自己用": "A dealer-created channel is only for that dealer",
  "不能低于 {v}": "Not below {v}",
  "代销商下单时自己改的折扣、自己建的渠道折扣都不能低于这个数(0.4 = 4 折)· 公司配的渠道折扣、公司代录不受限 · 留空 = 不限": "Discounts the dealer changes on orders, and the discounts on channels they create, can't go below this (0.4 = 40%) · company channel discounts and orders entered by the company aren't limited · blank = no limit",
  "按代销商自建渠道折扣 · 价格表 {v}": "Dealer-created channel discount · price list {v}",
  "还没有渠道 · 可到「销售渠道」页签自己建": "No channels yet · you can create one on the \"Sales channels\" tab",
  "去代销商配置": "Go to Dealers",
  "代销商零售单怎么收款、审批通过后交给谁发货、要不要走链路记账": "How dealer retail orders are paid, who ships them after approval, and whether to book them through the chain",
  "代销商月结": "Dealer monthly settlement",
  "每单付款截图": "Payment screenshot per order",
  "代销商自己收顾客的钱,下单不用传付款截图;审批通过不生成收款单,按审批通过的月份每月 1 号给每个代销商出一张待核对收款单(散单「月结」页也能手动出账)。": "Dealers collect from customers themselves, no payment screenshot needed; approval doesn't create a receipt — on the 1st of each month every dealer gets one receipt to verify, grouped by approval month (you can also bill manually on the Retail \"Monthly\" tab).",
  "顾客扫码付款,代销商下单时传付款截图;审批通过每单生成一张待核对收款单。": "Customers pay by QR code and the dealer uploads a payment screenshot; each approved order creates a receipt to verify.",
  "改了只影响以后审批的单。": "Changes only affect orders approved afterwards.",
  "{name} · 下单、看审批和发货进度 · 每月跟公司结一次": "{name} · place orders, track approval and shipping · settle with the company once a month",
  "代销商下的零售单 · 代销商自己收款,按月跟我们结": "Retail orders from dealers · dealers collect payment themselves and settle with us monthly",
  "核对结算金额无误后通过 · 月结:不生成收款单,月底按代销商汇总出账": "Approve once the settlement amount is right · monthly settlement: no receipt now, billed per dealer at month end",
  "已通过 · 记入 {month} 月结": "Approved · added to {month} monthly settlement",
  "已审批的单取消后,如果已经出了月结收款单,从里面扣掉这张单(还没核对到账才行)": "If an approved order is cancelled after its monthly receipt was issued, it is deducted from that receipt (only while the receipt is unverified)",
  "月结收款单": "Monthly receipt",
  "{month} 整月": "whole month {month}",
  "待付款": "To be paid",
  "已收到": "Received",
  "记入 {month} 月结 · 还没出账(次月 1 号出账)": "In {month} monthly settlement · not billed yet (billed on the 1st of next month)",
  "{month} 还没过完 · 现在出账,之后再审批的单下次另出一张。给 {n} 个代销商各生成一张待核对收款单?": "{month} isn't over yet · if you bill now, orders approved later go on a separate receipt. Create a receipt to verify for each of {n} dealers?",
  "给 {month} 还没出账的 {n} 个代销商各生成一张待核对收款单?": "Create a receipt to verify for each of the {n} dealers not yet billed for {month}?",
  "月结出账": "Monthly billing",
  "出账": "Bill",
  "已生成 {n} 张收款单 · 到【收付款管理】核对到账": "{n} receipts created · verify them under Receipts & Payments",
  "出账(生成收款单)": "Bill (create receipts)",
  "未出账": "Not billed",
  "顾客的钱你自己收,每月跟公司结一次 · 按审批通过的日子算月份 · 每月 1 号出上个月的账": "You collect from customers yourself and settle with the company once a month · the month is the approval date · last month is billed on the 1st",
  "代销商自己收顾客的钱,按月跟我们结 · 按审批通过的日子(北京时间)算月份 · 每月 1 号凌晨自动给上月出账:每个代销商一张待核对收款单,到【收付款管理】核对到账 · 已出账的单取消时从收款单里扣掉": "Dealers collect from customers and settle with us monthly · the month is the approval date (Beijing time) · last month is billed automatically early on the 1st: one receipt per dealer, verified under Receipts & Payments · cancelling a billed order deducts it from the receipt",
  "现在是每单付款截图,不走月结": "Payment is per order with screenshots right now, not monthly",
  "收款方式现在是「每单付款截图」· 月结只算改成月结以后审批的单 · 管理员到【系统设置 → 散单】改": "Payment method is currently \"payment screenshot per order\" · monthly settlement only covers orders approved after switching · admins can change it in Settings → Retail orders",
  "这个月没有按月结的散单": "No monthly-settled retail orders this month",
  "去收付款管理核对到账 →": "Verify in Receipts & Payments →",
  "这里列的是「{name}」配了价的产品 · 要加 / 减产品,到【代销商配置】给它配价或停价": "These are the products \"{name}\" has prices for · to add or remove products, set or stop its prices on the \"Dealers\" tab",
  "这里列的是代销商配了价的产品(所有代销商合起来)· 要加 / 减产品,到【代销商配置】配价或停价": "These are the products any dealer has prices for · to add or remove products, set or stop prices on the \"Dealers\" tab",
  "配价代销商": "Dealers priced",
  "还没有代销商配了价的产品 · 到【代销商配置】给代销商加产品": "No dealer has priced products yet · add products for dealers on the \"Dealers\" tab",
  "按编号加入": "Add by code",
  "产品库售价": "Product library price",
  "还有 {n} 个产品没填结算价": "{n} products still have no settlement price",
  "或者粘贴编号(从 Excel 复制一列)": "Or paste codes (copy a column from Excel)",
  "加了 {n} 个": "Added {n}",
  "加了 {n} 个(已配价的不加)": "Added {n} (already-priced ones skipped)",
  "加了 {n} 个 · {m} 个编号产品库里没有(留在框里了):{codes}": "Added {n} · {m} codes aren't in the product library (left in the box): {codes}",
  "结算价 = 零售价 ×": "Settlement = retail ×",
  "零售价默认带产品库售价 · 每格都能改,手改过的不会被折扣覆盖": "Retail defaults to the product library price · every cell is editable, and edited cells aren't overwritten by the rate",
  "没有要加的产品": "No products to add",
  "全部保存": "Save all",
  "搜索结果全部加入": "Add all search results",
  "搜索选产品": "Search and pick products",
  "先粘贴产品编号(一行一个,或用逗号 / 空格隔开)": "Paste product codes first (one per line, or separated by commas / spaces)",
  "先在上面搜索选产品,或者粘贴一列编号": "Search and pick products above, or paste a column of codes",
  "要加 {n} 个": "{n} to add",
  "一行一个,或用逗号 / 空格隔开": "One per line, or separated by commas / spaces",
  "已加 {n} 个 · {m} 个本来就在价格表里,跳过": "Added {n} · {m} were already in the price list and skipped",
  "(已配价)": "(priced)",
  "已配价 · 跳过": "Priced · skipped",
  "折扣价 = 零售价 ×": "Discount price = retail ×",
  "{n} 个缺结算价": "{n} missing settlement price",
  "{n} 个已配价跳过": "{n} already priced, skipped",
  "加产品 · {name}": "Add products · {name}",
  "输入编号或名称搜索,点一下就加到下面": "Search by code or name, click to add below",
  "(已在下面)": "(already below)",
  "这张是已发货、只补记录的单:通过后不推给仓库": "This order has already shipped and is only being recorded: it won't be sent to the warehouse after approval",
  "只补记录": "Record only",
  "已发货 · 只补记录": "Already shipped · record only",
  "原发货": "Original shipment",
  "没填快递单号": "No tracking number entered",
  "只补记录 · 审批后不推给仓库": "Record only · not sent to the warehouse after approval",
  "货已经发出去了,只补订单记录(审批后不推给仓库)": "Goods already shipped, just recording the order (not sent to the warehouse after approval)",
  "原快递公司(选填)": "Original carrier (optional)",
  "原快递单号(选填)": "Original tracking no. (optional)",
  "原发货时间": "Original ship time",
  "填了快递单号:审批通过直接记成已发货 · 没填:审批后再点「回填物流」补 · 发货时间按北京时间": "With a tracking number: marked as shipped on approval · without: use \"Enter tracking\" after approval · ship time is Beijing time",
  "平台拉单 · 买家是平台上的买家,不用选客户": "Platform order · the buyer is a platform buyer, no customer to select",
  "原 SKU {code} · 没匹配上产品库 · 在上面选对应的产品,或者回列表点「匹配SKU」": "Original SKU {code} · not matched to the product library · pick the product above, or use \"Match SKU\" in the list",
  "国家 / 省州 / 城市": "Country / State / City",
  "缺收货地址 · 发货前在「收发货管理」的包裹里补(亚马逊自发货单拿不到买家地址)": "Missing address · fill it in on the parcel in \"Shipping\" before shipping (Amazon merchant-fulfilled orders come without the buyer's address)",
  "建单": "Created",
} as Record<string, string>;
